export default "../media/logo_TF7_white.f9e6439375c48ba0b3259136e3e48639.png";